import React from 'react';

const Details = () => {
    return (
        <section className="py-20 px-6 bg-wedding-ivory text-center">
            <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
                <div className="flex flex-col items-center space-y-3">
                    <span className="uppercase tracking-widest text-xs text-wedding-gray font-bold">When</span>
                    <h3 className="font-serif text-3xl text-wedding-charcoal">April 27, 2026</h3>
                    <p className="text-wedding-gray font-light">10:00 AM</p>
                </div>
                <div className="flex flex-col items-center space-y-3 border-t md:border-t-0 md:border-l md:border-r border-wedding-beige pt-8 md:pt-0 px-0 md:px-8">
                    <span className="uppercase tracking-widest text-xs text-wedding-gray font-bold">Where</span>
                    <h3 className="font-serif text-3xl text-wedding-charcoal">St Mary's Farone Church Parish Hall</h3>
                    <p className="text-wedding-gray font-light">Upputhara</p>
                    <a
                        href="https://www.google.com/maps/search/?api=1&query=St+Mary%27s+Farone+Church+Parish+Hall+Upputhara"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-wedding-gold hover:text-wedding-charcoal transition-colors duration-300 text-sm font-medium"
                    >
                        View on Map
                    </a>
                </div>

                <div className="flex flex-col items-center space-y-3 pt-8 md:pt-0 border-t md:border-t-0 border-wedding-beige">
                    <span className="uppercase tracking-widest text-xs text-wedding-gray font-bold">Attire</span>
                    <h3 className="font-serif text-3xl text-wedding-charcoal">Look Expensive</h3>
                    <p className="text-wedding-gray font-light">But please don't outshine the bride</p>
                </div>
            </div>
        </section>
    );
};

export default Details;
